import { useEffect, useState } from "react";
import { useParams} from "react-router-dom";
import { toast } from "sonner";
import { Check, ArrowLeft, Loader2, Lock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { getToolkit, startCheckout } from "@/lib/api";

const ToolkitDetail = () => {
  const { id } = useParams();
  const [t, setT] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => { getToolkit(id).then(setT).catch(() => setT(false)); }, [id]);

  const buy = async () => {
    setLoading(true);
    try {
      const { checkout_url } = await startCheckout({ lookup_key: t.lookup_key, origin_url: window.location.origin });
      window.location.href = checkout_url;
    } catch (e) {
      toast.error("Couldn't start checkout. Please try again.");
      setLoading(false);
    }
  };

  if (t === false) return <div className="pt-40 pb-24 text-center text-sage-300">Toolkit not found. <a href="/toolkits" className="text-golden-500">Back to toolkits</a></div>;
  if (!t) return <div className="pt-40 pb-24 text-center text-sage-300"><Loader2 className="h-6 w-6 animate-spin mx-auto" /></div>;

  return (
    <div data-testid="toolkit-detail-page" className="pt-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
        <a href="/toolkits" className="inline-flex items-center gap-2 text-sage-300 hover:text-golden-500 transition-colors duration-300 mb-10">
          <ArrowLeft className="h-4 w-4" /> All toolkits
        </a>
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <Reveal>
            <div className="aspect-[4/5] rounded-sm overflow-hidden border border-forest-700 sticky top-28">
              <img src={t.image} alt={t.name} className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-xs uppercase tracking-[0.3em] text-golden-500 font-semibold mb-4">Digital Toolkit</p>
            <h1 className="font-serif text-4xl md:text-6xl text-sage-100 leading-tight mb-4">{t.name}</h1>
            <p className="text-sage-300 text-lg leading-relaxed mb-8">{t.description}</p>

            <div className="border border-forest-700 rounded-sm p-6 mb-8 bg-forest-900">
              <p className="text-sm text-sage-400 mb-1">{t.starting_at}</p>
              <p className="font-serif text-4xl text-sage-100 mb-6">${t.price.toFixed(2)}</p>
              <button
                data-testid="buy-toolkit-btn"
                onClick={buy}
                disabled={loading}
                className="group w-full flex items-center justify-center gap-2 bg-golden-500 text-navy font-semibold py-4 rounded-sm transition-colors duration-300 hover:bg-golden-600 disabled:opacity-60"
              >
                {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Lock className="h-4 w-4" /> Buy & download instantly</>}
              </button>
              <p className="text-xs text-sage-400 mt-3 text-center">Secure checkout via Stripe. Instant digital delivery.</p>
            </div>

            <h3 className="font-serif text-2xl text-sage-100 mb-4">What's inside</h3>
            <ul className="space-y-3">
              {t.includes.map((item, i) => (
                <li key={i} className="flex gap-3 text-sage-200"><Check className="h-5 w-5 text-golden-500 shrink-0 mt-0.5" />{item}</li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  );
};

export default ToolkitDetail;
